import { eventsHandler } from './queue'
import { redirectAfterSignin } from './handlers/signin-redirect'
import { Event } from './events'

eventsHandler.addHandler(Event.Signin, redirectAfterSignin.doAfterSignin)
eventsHandler.addHandler(Event.PageLoad, redirectAfterSignin.doOnPageLoad)
